<template>
<form @keyup.enter="save">
  <div>
    <div class="control is-horizontal">
      <div class="control-label">
        <label class="label field-required">Name</label>
      </div>
      <div class="control is-grouped">
        <p class="control is-expanded">
          <input v-validate="'required|max:255'"
                 :class="{'is-danger': errors.has('name') }" name="name"
                 v-model="body.name" class="input" type="text" placeholder="Enter name">
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </p>
      </div>
    </div>

    <div class="control is-horizontal">
      <div class="control-label">
        <label class="label field-required">Address</label>
      </div>
      <div class="control is-grouped">
        <p class="control is-expanded">
          <input v-validate="'required|max:255'" id="autocompletelocation"
                 :class="{'is-danger': errors.has('address') }"
                 name="address" @focus="geoLocate('autocompletelocation')"
                 v-model="body.address" class="input" type="text"
                 placeholder="Enter address">
          <span v-show="errors.has('address')"
                class="help is-danger">{{ errors.first('address') }}</span>
        </p>
      </div>
    </div>

    <div class="control is-horizontal">
      <div class="control-label">
        <label class="label"></label>
      </div>
      <div class="control">
        <a @click="cancel" class="button is-link">Cancel</a>
        <save-button :loading="isSaving" @click="save"/>
      </div>
    </div>
  </div>
</form>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        default() {
          return {}
        }
      },
      isSaving: Boolean
    },
    data() {
      return {
        body: {
          name: this.data.name ? this.data.name : '',
          address: this.data.address ? this.data.address : ''
        }
      }
    },
    methods: {
      geoLocate(elm) {
        let me = this;
        let options = {
          types: ['address']
        };
        try {
          let autocomplete = new google.maps.places.Autocomplete(document.getElementById(elm), options);
          autocomplete.addListener('place_changed', function () {
            let place = this.getPlace();
            me.body.address = place.formatted_address
          });
        } catch (e) {
          console.log(e.message)
        }
      },
      cancel() {
        this.$emit('cancel');
      },
      save() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$emit('save', this.body);
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>